export enum WalletType {
  FleatoWallet = "FleatoWallet",
  ConnectedWallet = "ConnectedWallet"
}